import React, { ReactNode } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

type ConfirmSigningDialogProps = {
  title: string;
  description: ReactNode;
  isOpen: boolean;
  onClickAction: () => void;
  onToggle: () => void;
};

export const ConfirmSigningDialog: React.FC<ConfirmSigningDialogProps> = ({
  description,
  isOpen,
  onClickAction,
  onToggle,
  title,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      className="modal-dialog-centered modal-sm"
      modalClassName="modal-danger"
    >
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <div className="border border-danger rounded p-2 d-flex align-items-center">
          {description}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={onToggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={onClickAction}>
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
